import axios from 'axios';

const API = axios.create({
  baseURL: 'https://api.yibeworld.com/api/v1',
  withCredentials: true,
});

export const getProducts = (params?: Record<string, string>) =>
  API.get('/products/', { params });

export const getProduct = (slug: string) =>
  API.get(`/products/${slug}/`);

export const getCategories = () =>
  API.get('/categories/');

export const getCart = () =>
  API.get('/cart/');

export const addToCart = (data: { product: number; quantity?: number; size?: string; color?: string }) =>
  API.post('/cart/add/', data);

export const updateCartItem = (id: number, quantity: number) =>
  API.patch(`/cart/${id}/update/`, { quantity });

export const removeFromCart = (id: number) =>
  API.delete(`/cart/${id}/remove/`);

export const createOrder = (data: Record<string, string>) =>
  API.post('/orders/create/', data);

export default API;
